import { DEDALO_DOMAIN } from '@/api/dedaloApi';

export function getPosterframe(video_url) {
    if (!video_url) return null;
    const posterframePath = video_url
        .replace(/\/404\//g, '/posterframe/')
        .replace(/\.mp4/g, '.jpg')
        .split('?')[0];
    return DEDALO_DOMAIN + posterframePath;
}

export function getImageUrl(file_path) {
    if (!file_path) return null;
    return DEDALO_DOMAIN + file_path;
}

export function termIdToSlug(termId) {
    const termIdToSlugMap = {
        navarra451_15: 'reivindicacion',
        navarra451_17: 'represion',
        navarra451_22: 'resistencia',
    };

    return termIdToSlugMap[termId] || null;
}

export function buildTree(items = [], rootId = 'navarra451_1') {
    if (!Array.isArray(items) || items.length === 0) return [];

    const map = new Map();
    items.forEach((item) => {
        map.set(String(item.term_id), { ...item, children: [] });
    });

    const roots = [];
    const extra = {};

    map.forEach((node) => {
        if (node.term_id === 'navarra451_36') {
            extra.informe = node;
            return;
        }
        if (node.term_id === 'navarra451_37') {
            extra.creditos = node;
            return;
        }
        if (node.term_id === 'navarra451_53') {
            extra.represaliadas = node;
            return;
        }
        const parentId = String(node.parent);
        if (parentId === rootId) {
            roots.push(node);
        } else {
            const parentNode = map.get(parentId);
            if (parentNode) {
                parentNode.children.push(node);
            } else {
                console.warn(`Parent ${parentId} not found for node ${node.term_id}; ignoring.`);
            }
        }
    });

    const pathOrder = roots.reduce((acc, curr) => {
        acc.push(curr.web_path);
        curr.children.forEach((child) => {
            if (child.web_path) {
                acc.push(child.web_path);
            }
        });
        return acc;
    }, []);

    return { menu: roots, extra, pathOrder };
}